export default {"src":"/_next/static/media/backend-white.59abf68f.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};